import * as _ from 'lodash';

import { Component, OnInit, ViewChild, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MinValidator,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MembersService } from 'src/app/shared/services/members.service';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { CustomValidators } from 'src/app/shared/validators/custom.validator';
import { NotEmptyValidator } from 'src/app/shared/validators/not-empty.validator';
import { Image } from 'src/app/people/models/image';
import { LookupService, StateCountryLookupService } from 'src/app/shared/services/lookup.service';
import { PersonDetailsWrite } from 'src/app/people/models/personDetailsWrite';
import { of } from 'rxjs';
import { FileItem } from 'ng2-file-upload';
import { Race } from 'src/app/shared/models/race';
import { FormFieldName } from 'src/app/shared/models/application/formFieldName';
import { Application } from 'src/app/shared/models/application/application';
import { Gender } from 'src/app/shared/models/gender';
import { Form } from 'src/app/shared/models/application/form';
import { MembersResumeService } from 'src/app/shared/services/members-resume.service';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { BuildInfoCheckService } from 'src/app/shared/services/build-info-check.service';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { DemographicInfo } from 'src/app/people/models/demographicInfo';
import { LocalData, LocalPersistenceService } from '../local-persistence.service';
import { AttributesEditorDataSource } from 'src/app/shared/components/attributes-editor/attributesEditorDataSource';
import { AttributesEditorComponent } from 'src/app/shared/components/attributes-editor/attributes-editor.component';
import { DocumentScanEvent } from 'src/app/shared/models/documentScanEvent';
import { DocumentScanStatusType } from 'src/app/shared/models/documentScanStatusType';
import { AttributeEditorMode } from 'src/app/shared/models/attributes/attributeEditorMode';
import {
  FieldValidatorTracker,
  getAllControlErrors,
  getFailedValidationMessage,
} from 'src/app/shared/models/form/field-validator-tracker';
import { PersonForMemberRequests } from 'src/app/people/models/personForApplication';
import { ApplicationFormPage } from 'src/app/shared/models/application/formPage';
import { ApplicationPaymentComponent } from '../application-payment/application-payment.component';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';
import {
  AddressHelper,
  AddressHelperFactory,
} from 'src/app/shared/services/address-helper.service';
import {
  getHiddenAndRequired,
  isMailingAddressVisible,
} from 'src/app/shared/models/application/formField';
import { PaymentResult } from 'src/app/shared/models/application/paymentOptions';
import { SubmitApplicationResultModel } from 'src/app/shared/models/application/submitApplicationResultModel';
import { getParsedError } from 'src/app/shared/services/base.service';
import {
  buildApplicationSubmit,
  buildPaymentPreview,
} from 'src/app/shared/models/application/applicationSubmit';
import { cleanPhoneNumber } from 'src/app/shared/components/phone/phone.component';

const empty: Race[] = [];

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss'],
})
export class ApplicationComponent implements OnInit, OnDestroy {
  get inPreviewMode() {
    return !!this.onPreviewSubmit;
  }
  @Input()
  previewFormId: string;
  @Input()
  onPreviewSubmit: Function;
  private applicationSubscription;
  private personSubscription;
  private routeSubscription;
  private racesSubscription;
  totalPages: number = 1;
  selectedIndex: number = 0;
  private isHeaderButtonVisible = false;
  isSaving: boolean = false;
  isLoading: boolean = true;
  disableSubmit: boolean = false;
  displayUploadAndDeleteButtons: boolean = true;
  getFailedValidationMessage = getFailedValidationMessage; //make available in html
  uploadErrorMessage: string = '';
  formFailedValidations: FieldValidatorTracker[] = [];
  pageFailedValidations: FieldValidatorTracker[] = [];

  formPages: ApplicationFormPage[] = [];
  get showSpinner() {
    return this.isSaving || this.isLoading;
  }

  get mode(): AttributeEditorMode {
    if (this.inPreviewMode) {
      return AttributeEditorMode.Preview;
    } else {
      return AttributeEditorMode.Application;
    }
  }
  application: Application = Application.blank();
  person: PersonForMemberRequests = new PersonForMemberRequests();
  /** If true; is existing person */
  isUpdateMode: boolean = false;
  applicationForm: FormGroup<{
    phoneNumber: FormControl<string>;
    extension: FormControl<string>;
    phoneNumberRaw: FormControl<string>;
    firstName: FormControl<string>;
    suffix: FormControl<string>;
    lastName: FormControl<string>;
    middleName: FormControl<string>;
    email: FormControl<string>;
    jobTitle: FormControl<string>;
    company: FormControl<string>;
    linkedInProfile: FormControl<string>;
    gender: FormControl<string>;
    races: FormControl<Race[]>;
    resumeUpload: FormControl<string>;
  }>;
  isRequired: Partial<Record<FormFieldName, boolean>> = {};
  isHidden: Partial<Record<FormFieldName, boolean>> = {};
  addressHelper: AddressHelper;
  image: Image;
  races: Race[] = [];
  resumeCvFile: FileItem;
  errorMessage: string;
  secureLinkId: string;
  /** if has introduction text, defaults to true */
  isIntroductionVisible: boolean = true;
  attributesEditorDataSource = new AttributesEditorDataSource();
  activePage: ApplicationFormPage;
  @ViewChild('attributesEditor', { static: false }) attributesEditor: AttributesEditorComponent;

  get gender() {
    return Gender;
  }

  /** alias of this.application.form */
  get form(): Form {
    return this.application.form;
  }
  private getStateCountryLookupPromise: Promise<StateCountryLookupService>;
  constructor(
    private localPersistenceService: LocalPersistenceService,
    private applicationService: ApplicationService,
    private formBuilder: FormBuilder,
    private membersService: MembersService,
    private router: Router,
    private route: ActivatedRoute,
    private lookupService: LookupService,
    private membersResumeService: MembersResumeService,
    private appConfigService: AppConfigService,
    private buildInfoCheckService: BuildInfoCheckService,
    private snackBarService: SnackBarService,
    private addressHelperFactory: AddressHelperFactory,
    private cdr: ChangeDetectorRef
  ) {
    this.getStateCountryLookupPromise = this.lookupService.getStateCountryLookup();
  }

  async stepperChange(event) {
    this.selectedIndex = event.selectedIndex;
    if (this.selectedIndex + 1 > this.formPages.length) {
      this.saveForLater();
      const paymentPreview = buildPaymentPreview(
        this.createPersonDetailsWriteModel(),
        this.attributesEditorDataSource,
        this.person?.id
      );

      await this.paymentComponent.loadPayments(
        this.secureLinkId,
        this.addressHelper?.getDemographicInfoFromForm(),
        paymentPreview
      );
    } else {
      this.activePage = this.formPages[this.selectedIndex];
    }
  }

  /** for unit tests. spying 'ngOnInit' does not work, but onInit does */
  ngOnInit() {
    this.onInit();
  }

  onInit() {
    this.buildInfoCheckService.onReloadPrompt.subscribe(() => {
      this.saveForLater();
    });

    this.racesSubscription = this.lookupService.races.subscribe((races) => (this.races = races));

    if (this.inPreviewMode && this.previewFormId) {
      this.applicationSubscription = this.applicationService
        .getForPreview(this.previewFormId)
        .subscribe(async (application) => {
          this.setApplication(application);
          this.setApplicationData([], null, await this.getStateCountryLookupPromise);
        });
      return;
    }

    this.routeSubscription = this.route.params.subscribe((params) => {
      let personId = params['personId'];
      this.secureLinkId = params['secureLinkId'];
      let personObservable = of(this.person);

      if (personId) {
        this.isUpdateMode = true;
        personObservable = this.membersService.getPerson(personId, this.secureLinkId);
      }

      this.applicationSubscription = this.applicationService
        .getBySecureLinkId(this.secureLinkId)
        .subscribe((application) => {
          if (application) {
            if (application.hasExpired) {
              this.router.navigate(['/members/application/closed']);
              return;
            }
            this.setApplication(application);
            this.personSubscription = personObservable.subscribe(async (person) => {
              this.person = person;
              this.image = this.person.image;
              const stateCountyLookupService = await this.getStateCountryLookupPromise;
              const { attributes, demographicInfo } =
                this.getAttributesAndDemographicInfo(stateCountyLookupService);

              this.setApplicationData(attributes, demographicInfo, stateCountyLookupService);
            });
          }
        });
    });
  }
  private buildForm = () =>
    this.formBuilder.group({
      firstName: ['', [NotEmptyValidator()]],
      middleName: ['', this.isRequired.MiddleName ? [NotEmptyValidator()] : []],
      lastName: ['', [NotEmptyValidator()]],
      suffix: ['', [Validators.maxLength(15)]],
      email: [
        { value: this.application.email, disabled: true },
        [NotEmptyValidator(), Validators.email],
      ],
      phoneNumber: [
        '',
        this.isRequired.PhoneNumber
          ? [Validators.minLength(5), NotEmptyValidator()] //min 5 because you can type a single digit or '+1' and the phone validation won't kick in. But at 3 characters phone validation will kick in
          : [Validators.minLength(5)],
      ],
      phoneNumberRaw: [''],
      extension: [''],
      gender: ['', this.isRequired.Gender ? [NotEmptyValidator()] : []],
      races: [empty, this.isRequired.Race ? [NotEmptyValidator()] : []],
      jobTitle: ['', this.isRequired.JobTitle ? [NotEmptyValidator()] : []],
      company: ['', this.isRequired.Company ? [NotEmptyValidator()] : []],
      linkedInProfile: [
        '',
        this.isRequired.LinkedIn
          ? [CustomValidators.urlValidator(), NotEmptyValidator('LinkedIn Profile is required')]
          : [CustomValidators.urlValidator()],
      ],
      resumeUpload: [
        '',
        this.isRequired.Resume ? [NotEmptyValidator('Resume or Curriculum Vitae is required')] : [],
      ],
    });

  //called once
  setApplication(application: Application) {
    this.application = application;
    const hiddenAndRequired = getHiddenAndRequired(this.form.fields);
    this.isRequired = hiddenAndRequired.isRequired;
    this.isHidden = hiddenAndRequired.isHidden;

    this.applicationForm = this.buildForm();

    const { formPages, totalPages } = this.getPages(application);
    this.formPages = formPages;
    this.totalPages = totalPages;
    this.activePage = this.formPages[0];
    this.isLoading = false;

    this.setIntroductionTextVisibility();
  }

  private getPages(application: Application): {
    formPages: ApplicationFormPage[];
    totalPages: number;
  } {
    const formPages: ApplicationFormPage[] = [];
    application.pages.forEach(function (page, i) {
      if (i == 0) {
        formPages.push(ApplicationFormPage.parse(page));
      } else if (
        application.questions &&
        application.questions.filter((x) => x.formPageId == page.id).length > 0
      ) {
        formPages.push(ApplicationFormPage.parse(page));
      }
    });
    const totalPages = formPages.length + (application.form.includePaymentPage ? 1 : 0);
    return {
      formPages,
      totalPages,
    };
  }

  onBackClick() {
    this.pageFailedValidations = [];
    this.formFailedValidations = [];
    if (typeof window != 'undefined') {
      window.scrollTo(0, 0);
    }
    this.saveForLater();
  }

  onNextClick(page: ApplicationFormPage) {
    if (this.isPageValid(page)) {
      this.pageFailedValidations = [];
      if (typeof window != 'undefined') {
        window.scrollTo(0, 0);
      }
      this.saveForLater();
    } else {
      this.generatePageFailedValidatorMessageSummary(page);
    }
  }
  //called once
  private setApplicationData = (
    attributes: Attribute[] = [],
    demographicInfo: DemographicInfo,
    stateCountryLookupService: StateCountryLookupService
  ) => {
    this.cdr.detectChanges();
    this.updateApplicationForm(demographicInfo);
    if (this.form.hasQuestions) this.setupApplicationQuestions(attributes);

    this.buildInfoCheckService.initBuildFileCheck("Don't worry, you won't lose your progress!");

    if (!isMailingAddressVisible(this.isHidden)) {
      return;
    }
    this.addressHelper = this.addressHelperFactory.buildSync(
      demographicInfo,
      this.inPreviewMode
        ? this.previewFormId
        : this.isUpdateMode
        ? this.person.id
        : this.secureLinkId,
      this.isRequired,
      this.isHidden,
      this.form.isAddressSharedLabel,
      stateCountryLookupService
    );
  };

  /** Gets DemographicInfo from local storage or person is local storage not set*/
  private getAttributesAndDemographicInfo = (
    stateCountryLookupService: StateCountryLookupService
  ): {
    attributes: Attribute[];
    demographicInfo: DemographicInfo;
  } => {
    const localData = this.localPersistenceService.getLocalData<LocalData<PersonDetailsWrite>>(
      this.secureLinkId
    );
    if (!localData) {
      //localData falsy on first load or in preview mode?
      return this.isUpdateMode
        ? { attributes: this.person.attributes, demographicInfo: this.person.demographicInfo } //set from API, no local storage
        : { attributes: [], demographicInfo: null }; //(preview mode): no local, no api
    }
    let attributes = [];
    let hiddenAndReadonlyQuestions = this.application.questions.filter(
      (x) => x.isReadOnly || x.isHidden
    );
    hiddenAndReadonlyQuestions.forEach((q) => {
      let attr = this.person.attributes.find((x) => x.attributeDefinitionId == q.id);
      if (attr) {
        attributes.push(attr);
      }
    });
    const loadedAttributes = localData.answers
      ? LocalPersistenceService.buildFormUsingSavedAnswers(
          localData.answers,
          this.application.questions
        )
      : [];
    attributes = attributes.concat(loadedAttributes);
    const demographicInfo = stateCountryLookupService.buildDemographicInfo(localData.reference);
    return {
      attributes,
      demographicInfo: this.buildDemographicInfoFromCache(demographicInfo, localData.reference),
    }; //set from local storage
  };

  private setupApplicationQuestions = (attributes: Attribute[]) => {
    this.attributesEditorDataSource.sortOnName = false;
    this.attributesEditorDataSource.load(
      this.application.filterForShowCurrentValues(attributes),
      this.application.questions
    );
  };

  //note: personDetailsFromCache is never falsy
  private buildDemographicInfoFromCache = (
    demographicInfo: DemographicInfo,
    personDetailsFromCache: PersonDetailsWrite
  ): DemographicInfo => {
    demographicInfo.races = personDetailsFromCache.races;
    demographicInfo.gender = personDetailsFromCache.gender;
    return demographicInfo;
  };

  ngOnDestroy(): void {
    if (this.applicationSubscription) this.applicationSubscription.unsubscribe();
    if (this.personSubscription) this.personSubscription.unsubscribe();
    if (this.routeSubscription) this.routeSubscription.unsubscribe();
    if (this.racesSubscription) this.racesSubscription.unsubscribe();
  }

  public getPlaceholderFor(fieldName: string) {
    return this.isRequired[fieldName] ? 'Required' : '';
  }

  public getRequiredFor(fieldName: string) {
    return this.isRequired[fieldName] ? ' *' : '';
  }

  public hasError(fieldName: string, errorCode: string) {
    return (
      this.applicationForm.get(fieldName).touched &&
      this.applicationForm.get(fieldName).hasError(errorCode)
    );
  }

  private updateApplicationForm(demographicInfo: Pick<DemographicInfo, 'gender' | 'races'>) {
    this.applicationForm.patchValue({
      gender: demographicInfo?.gender,
      races: demographicInfo?.races ?? empty,
      firstName: this.person.firstName,
      suffix: this.person.suffix,
      middleName: this.person.middleName,
      lastName: this.person.lastName,
      phoneNumber: this.person.phoneNumber,
      phoneNumberRaw: cleanPhoneNumber(this.person.phoneNumber),
      extension: this.person.extension,
      jobTitle: this.person.jobTitle,
      company: this.person.company,
      linkedInProfile: this.person.linkedInProfile,
    });
  }

  //result is saved in local storage
  private createPersonDetailsWriteModel = (): PersonDetailsWrite => {
    const model = new PersonDetailsWrite({
      ...this.applicationForm.value,
      tags: this.person.tags,
      status: this.isUpdateMode ? this.person.status : this.application.form.newMemberDefaultStatus,
      email: this.application.email,
    });
    let address: DemographicInfo;

    if (this.addressHelper) {
      address = this.addressHelper.getDemographicInfoFromForm();
      model.addressValidationCacheKey = this.form.validateAddress
        ? this.addressHelper.addressValidationCacheKey
        : '';
    } else {
      address = this.person.demographicInfo;
      //application does not use address
    }
    model.setAddress(address);

    return model;
  };

  @ViewChild(ApplicationPaymentComponent, { static: true })
  paymentComponent: ApplicationPaymentComponent;
  submitApplication = async () => {
    if (!this.isFormValid()) {
      this.markAllAsTouched();
      this.generateFailedValidatorMessageSummary();
      return;
    }

    if (this.isSaving) return;

    this.isSaving = true;
    try {
      let stripeResult: PaymentResult;
      if (this.hasPaymentPage()) {
        const result = await this.paymentComponent.completePayment();
        if (result.isFailed === true) {
          //payment failed. Should have done a snack bar error/console.error
          return;
        }
        stripeResult = result;
      }
      //payment successful OR no payment page
      if (this.inPreviewMode) {
        this.onPreviewSubmit();
        return; //preview mode; do no other work
      }
      await this.sendApplicationToApi(stripeResult);
    } catch (error) {
      const parsedMessage = getParsedError(error);
      if (parsedMessage.isGenericError && error.message) {
        this.snackBarService.open(error.message, false); //display error.message instead of parsedMessage.isGenericError
      } else {
        this.snackBarService.open(parsedMessage.message, false);
      }
    } finally {
      this.isSaving = false;
    }
  };

  private navigateToConfirmationPage = (submitApplicationResult: SubmitApplicationResultModel) => {
    const navState = {
      ...submitApplicationResult,
      checkInstructions: this.paymentComponent.paymentOptions?.checkInstructions,
      confirmationMessage: this.form.confirmation,
    };
    this.router.navigate(['members', 'confirmation'], { state: navState });
  };

  //checks if has payment page OR
  private hasPaymentPage = () => {
    const currentPageNumber = this.selectedIndex + 1;

    if (currentPageNumber < this.formPages.length) {
      const errorMessage = `Not on last page of application! Page ${currentPageNumber} of ${this.formPages.length}`;

      throw Error(errorMessage);
    }
    if (currentPageNumber == this.formPages.length) {
      return false; //On last Page; No payment
    }
    if (this.form.includePaymentPage) {
      return true;
    }
    console.error(
      `expected ${currentPageNumber} to be the payment page, but includePaymentPage is false`
    );
    return false;
  };

  public sendApplicationToApi = async (paymentResult: PaymentResult) => {
    const payload = buildApplicationSubmit(
      this.createPersonDetailsWriteModel(),
      this.attributesEditorDataSource,
      this.person?.id,
      paymentResult,
      this.image
    );
    const submitApplicationResult = await this.membersService
      .submitApplication(this.secureLinkId, payload)
      .then(async (submitResult) => {
        await this.uploadResumeIfNecessary(submitResult.personId);
        return submitResult;
      });

    //if exception is throw in API, will not delete local data or navigate;
    this.localPersistenceService.deleteLocalData(this.secureLinkId);
    this.navigateToConfirmationPage(submitApplicationResult);
  };

  //public for tests
  generateFailedValidatorMessageSummary() {
    this.formFailedValidations = this.getFormPageValidationErrors();
  }

  private generatePageFailedValidatorMessageSummary(page: ApplicationFormPage) {
    this.pageFailedValidations = this.getFormPageValidationErrors(page);
  }

  private getFormPageValidationErrors = (
    page: ApplicationFormPage = null
  ): FieldValidatorTracker[] =>
    [
      this.getFieldFailedValidations(),
      this.getAddressFailedValidations(),
      this.getPageQuestionsFailedValidations(page),
    ].flat();

  private getFieldFailedValidations(): FieldValidatorTracker[] {
    var failedValidations: FieldValidatorTracker[] = [];

    Object.keys(this.applicationForm.controls).forEach((fieldName) => {
      const control: AbstractControl = this.applicationForm.get(fieldName);

      //races is a container of options not an input per se, use name to find it by id
      //phoneNumberRaw is an internal control used by ngx-mat-intl-tel-input. Find by id
      const controlId =
        fieldName == 'races' ? fieldName : fieldName == 'phoneNumberRaw' ? 'PhoneNumber' : null;

      failedValidations = failedValidations.concat(
        getAllControlErrors(controlId, fieldName, control)
      );
    });

    return failedValidations;
  }
  private getPageQuestionsFailedValidations(page: ApplicationFormPage): FieldValidatorTracker[] {
    var failedValidations: FieldValidatorTracker[] = [];

    const editableAttributes: Map<string, AbstractControl> = page
      ? this.attributesEditor.nonValidAttributesinPage(page)
      : this.attributesEditor.nonValidAttributes();
    editableAttributes.forEach((control: AbstractControl, controlId: string) => {
      failedValidations.push(...getAllControlErrors(controlId, null, control));
    });

    return failedValidations;
  }

  private getAddressFailedValidations = (): FieldValidatorTracker[] =>
    this.addressHelper ? this.addressHelper.getInvalidFields() : [];

  updateFieldValidatorStatus = (page: ApplicationFormPage) => {
    if (this.formFailedValidations.length) {
      this.generateFailedValidatorMessageSummary();
    }
    if (this.pageFailedValidations.length) {
      this.generatePageFailedValidatorMessageSummary(page);
    }
  };

  //called when address modal closed
  addressUpdated = (page: ApplicationFormPage) => {
    this.updateFieldValidatorStatus(page);
    this.saveForLater(); //saveForLater saves address to local storage
  };

  onResumeUpload = (): ((file: FileItem) => void) => (file: FileItem) => {
    this.resumeCvFile = file;
    this.applicationForm.controls.resumeUpload.setValue(this.resumeCvFile.file.name);
  };

  onResumeClear() {
    this.resumeCvFile = null;
    this.applicationForm.controls.resumeUpload.setValue('');
  }

  noResumeUploaded() {
    return this.resumeCvFile ? false : true;
  }

  processVirusScanResults(result: DocumentScanEvent, page: ApplicationFormPage) {
    let defaultErrorMessage = 'Virus scan failed. Please try uploading the document again.';
    if (result.status == DocumentScanStatusType.Started) {
      this.disableSubmit = true;
      this.displayUploadAndDeleteButtons = false;
    } else if (result.status == DocumentScanStatusType.Finished && !result.documentPassedScan) {
      this.displayUploadAndDeleteButtons = true;
      this.disableSubmit = false;
      this.uploadErrorMessage = result.errorMessage ? result.errorMessage : defaultErrorMessage;
      this.applicationForm.controls.resumeUpload.setErrors({ documentFailedScan: true });
    } else if (result.status == DocumentScanStatusType.Finished && result.documentPassedScan) {
      this.disableSubmit = false;
      this.displayUploadAndDeleteButtons = true;
      this.updateFieldValidatorStatus(page);
    } else if (result.status == DocumentScanStatusType.RequestFailed) {
      this.displayUploadAndDeleteButtons = true;
      this.disableSubmit = false;
      this.uploadErrorMessage = result.errorMessage ? result.errorMessage : defaultErrorMessage;
      this.applicationForm.controls.resumeUpload.setErrors({ documentScanRequestFailed: true });
    }

    if (this.uploadErrorMessage != '') {
      this.updateFieldValidatorStatus(page);
    }
  }

  private async uploadResumeIfNecessary(personId: string): Promise<any> {
    if (this.resumeCvFile) {
      await this.membersResumeService.uploadResume(this.resumeCvFile, personId);
    }
  }

  isFormValid = () => {
    if (!this.applicationForm.valid || !this.attributesEditorDataSource.isValid) {
      return false;
    }
    return this.addressHelper ? this.addressHelper.valid : true; //address might be turned off
  };

  isPageValid = (page: ApplicationFormPage): boolean => {
    if (!page.isValid || !this.applicationForm.valid) return false;
    return this.addressHelper ? this.addressHelper.valid : true; //address might be turned off
  };

  imageChangedCallbackReference = () => (image_id: string) => {
    this.image = new Image(image_id);
    this.errorMessage = null;
  };

  imageErrorCallbackReference = () => (error_message: string) => {
    this.errorMessage = error_message;
  };

  updateRace(race, event) {
    let personRaces = this.getPersonRaces();

    if (event.checked) {
      personRaces.push(race);
    } else {
      let unselected = _.find(personRaces, function (currentRace) {
        return currentRace.id == race.id;
      });

      _.remove(personRaces, function (race: Race) {
        return race.id == unselected.id;
      });
    }

    this.setPersonRaces(_.sortBy(personRaces, (r) => r.name));
  }

  getRaceCheckboxStatus(race) {
    return !!this.getPersonRaces().find((r) => r.id == race.id);
  }

  private getPersonRaces() {
    return this.applicationForm.controls.races.value;
  }

  private setPersonRaces(races) {
    this.applicationForm.controls.races.setValue(races);
  }

  private setIntroductionTextVisibility() {
    if (this.application && this.form && this.form.introduction) {
      return; //no work to do. Default is visible
    }
    this.isIntroductionVisible = false;
    this.setupHeaderButton();
  }

  isAppLoaded(): boolean {
    return this.form && !!this.form.id;
  }

  isAvatarVisible(): boolean {
    return !this.isHidden.Avatar;
  }

  isResumeVisible(): boolean {
    return !this.isHidden.Resume && this.appConfigService.tenant.plan.canUploadDocuments;
  }

  isLinkedInVisible(): boolean {
    return !this.isHidden.LinkedIn;
  }

  isPhoneNumberVisible(): boolean {
    return !this.isHidden.PhoneNumber;
  }

  isMiddleNameVisible(): boolean {
    return !this.isHidden.MiddleName;
  }

  isCompanyVisible(): boolean {
    return !this.isHidden.Company;
  }

  isGenderVisible(): boolean {
    return !this.isHidden.Gender;
  }

  isRaceVisible(): boolean {
    return !this.isHidden.Race;
  }

  isJobTitleVisible(): boolean {
    return !this.isHidden.JobTitle;
  }

  isSuffixVisible(): boolean {
    return !this.isHidden.Suffix;
  }

  isProfessionalInformationVisible(): boolean {
    return (
      this.isJobTitleVisible() ||
      this.isCompanyVisible() ||
      this.isLinkedInVisible() ||
      this.isResumeVisible()
    );
  }

  startApplication() {
    this.isIntroductionVisible = false;
    this.setupHeaderButton();
    if (window) {
      window.scroll({
        top: 0,
        left: 0,
      });
    }
  }

  downloadFile(event: { fileName: string; attributeDefinitionId: string }) {
    let requestUrl = `${this.secureLinkId}/${event.attributeDefinitionId}/document`;
    this.membersService.downloadFile(requestUrl, event.fileName);
  }
  private markAllAsTouched() {
    this.applicationForm.markAllAsTouched();
    if (this.form.hasQuestions) this.attributesEditor.markAllAsTouched();
    this.addressHelper?.addressFormGroup?.markAllAsTouched();
  }

  private setupHeaderButton() {
    if (this.isHeaderButtonVisible) return;

    this.localPersistenceService.buttonSubject.next({
      label: 'Save For Later',
      action: () => this.saveForLater(true),
      tooltip:
        'Your responses will be saved for 15 days. You must use the same device and browser when ' +
        "coming back. You must still submit responses once you're ready.",
    });
    this.isHeaderButtonVisible = true;
  }

  private saveForLater = (showMessage: boolean = false) =>
    this.localPersistenceService.saveDataForLater(
      this.buildLocalData(),
      this.secureLinkId,
      showMessage
    );

  private buildLocalData = (): LocalData<PersonDetailsWrite> => ({
    reference: this.createPersonDetailsWriteModel(),
    answers: this.form.hasQuestions
      ? this.localPersistenceService.getAnswers(this.attributesEditorDataSource)
      : [],
  });
}
